import current from '@/scripts/current'
import VariableSelection from '@/bo/VariableSelection';
import store from '@/store';

// initial state
// shape: [{ id, quantity }]
const state = {
    analysisType: null,
    apiFormData: null,
    selectionModel: null,
    data: null,
    loadingData: false,
    hasData: false,
    storeSelectionModel: null
}

// getters
const getters = {
    getHasData: state => state.hasData
}

function setAnalysis(commit, analysisType, apiFormData, serializedModel) {
    var selectionModel = JSON.parse(JSON.stringify(serializedModel)); //make a copy
    var storeSelectionModel = JSON.parse(JSON.stringify(store.state.selModel));
    commit('setTheData', { data: null, loadingData: true });
    commit('setTheAnalysis', { analysisType, apiFormData, selectionModel, storeSelectionModel });
}

// actions
const actions = {
    startCtAnalysis({ commit, state }, { apiFormData, selectionModel }) {
        setAnalysis(commit, 'ct', apiFormData, selectionModel);
    },
    startLrAnalysis({ commit, state }, { apiFormData, selectionModel }) {
        setAnalysis(commit, 'lr', apiFormData, selectionModel);
    },
    loadedData({ commit, state }, { apiFormData, data }) {
        if (apiFormData === state.apiFormData)
            commit('setTheData', { data: data, loadingData: false });
    },
    clearData({ commit, state }) {
        commit('setTheData', { data: null, loadingData: false });
    }
}

// mutations
const mutations = {
    setTheData(state, { data, loadingData }) {
        state.data = data;
        state.hasData = data !== null;
        state.loadingData = loadingData;
    },
    setTheAnalysis(state, { analysisType, apiFormData, selectionModel, storeSelectionModel }) {
        state.analysisType = analysisType;
        state.apiFormData = apiFormData;
        state.selectionModel = selectionModel;
        state.storeSelectionModel = storeSelectionModel;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
